import { Component, OnInit } from '@angular/core';
import { GenericPageComponent } from '@shared/modules/general-commons/components/generic-page/generic-page.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'stx-logout',
  imports: [GenericPageComponent, TranslateModule],
  templateUrl: 'logout.component.html'
})
export class LogoutComponent implements OnInit {
  ngOnInit(): void {
    window.location.replace('/');
  }
}
